export const getCurrentQueryParams = (): Record<string, string> => {
	if (typeof window === 'undefined' || !('location' in window)) {
		return {};
	}

	return Object.fromEntries(Array.from(new URLSearchParams(window.location.search)));
};
